// extracted by mini-css-extract-plugin
module.exports = {"btns":"newEducator_btns__1TpNw","selectors":"newEducator_selectors__dPvMc"};